// Landing page route entry points — thin wrappers around LandingPageTemplate
import React from 'react';
import LandingPageTemplate from './LandingPageTemplate';

import attackSurfaceMonitoringData from './data/attack-surface-monitoring';
import externalAttackSurfaceManagementData from './data/external-attack-surface-management';
import domainMonitoringData from './data/domain-monitoring';
import subdomainMonitoringData from './data/subdomain-monitoring';
import ipRangeMonitoringData from './data/ip-range-monitoring';
import dnsDriftMonitoringData from './data/dns-drift-monitoring';
import sslCertificateMonitoringData from './data/ssl-certificate-monitoring';
import exposedRdpMonitoringData from './data/exposed-rdp-monitoring';
import exposedSshMonitoringData from './data/exposed-ssh-monitoring';
import externalVulnerabilityScanningData from './data/external-vulnerability-scanning';

export function AttackSurfaceMonitoringPage() {
  return <LandingPageTemplate data={attackSurfaceMonitoringData} />;
}

export function ExternalAttackSurfaceManagementPage() {
  return <LandingPageTemplate data={externalAttackSurfaceManagementData} />;
}

export function DomainMonitoringPage() {
  return <LandingPageTemplate data={domainMonitoringData} />;
}

export function SubdomainMonitoringPage() {
  return <LandingPageTemplate data={subdomainMonitoringData} />;
}

export function IpRangeMonitoringPage() {
  return <LandingPageTemplate data={ipRangeMonitoringData} />;
}

export function DnsDriftMonitoringPage() {
  return <LandingPageTemplate data={dnsDriftMonitoringData} />;
}

export function SslCertificateMonitoringPage() {
  return <LandingPageTemplate data={sslCertificateMonitoringData} />;
}

export function ExposedRdpMonitoringPage() {
  return <LandingPageTemplate data={exposedRdpMonitoringData} />;
}

export function ExposedSshMonitoringPage() {
  return <LandingPageTemplate data={exposedSshMonitoringData} />;
}

export function ExternalVulnerabilityScanningPage() {
  return <LandingPageTemplate data={externalVulnerabilityScanningData} />;
}
